// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ogtked0 {
  max-width: 50%;
}
.ogtked1 {
  display: block;
  width: 100%;
  appearance: none;
  user-select: none;
  white-space: nowrap;
  border: 0;
  padding: 0;
  margin: 0;
  border-radius: var(--_18w76bw4t);
  transition: all 200ms;
}
.ogtked2 {
  border: var(--_18w76bw4q);
  border-color: var(--_18w76bw37);
  background-color: var(--_18w76bw26);
}
.ogtked2:hover {
  border-color: var(--_18w76bw2g);
}
.ogtked2:focus {
  border-color: var(--_18w76bw2g);
  box-shadow: none;
  outline: none;
}
.ogtked5 {
  border: none;
  background: transparent;
}
.ogtked6 {
  border: none;
  border-radius: 0;
  border-bottom: var(--_18w76bw4q);
  background: transparent;
}
.ogtked7 {
  background: white;
  border-radius: var(--_18w76bw4t);
  box-shadow: var(--_18w76bw4x);
  outline-width: 2px;
  outline-offset: 2px;
  outline-color: rgba(255,255,255,0.0);
  outline-style: solid;
}
.ogtked7:focus {
  outline-color: rgba(255,255,255,0.5);
}
.ogtked8 {
  color: white;
  border-color: rgba(255, 255, 255, 0.5);
}
.ogtked8::placeholder {
  color: white;
}
.ogtked9 {
  height: var(--_18w76bwm);
  padding-top: var(--_18w76bwc);
  padding-bottom: var(--_18w76bwc);
  padding-left: 10px;
  padding-right: var(--_18w76bwh);
  font-size: var(--_18w76bw3r);
}
.ogtkeda {
  font-size: var(--_18w76bw3s);
  height: var(--_18w76bwo);
  padding-top: 0;
  padding-bottom: 0;
  padding-left: var(--_18w76bwe);
  padding-right: var(--_18w76bwh);
}
.ogtkedc {
  font-size: var(--_18w76bw3u);
  height: var(--_18w76bwp);
  padding-top: 0;
  padding-bottom: 0;
  padding-left: var(--_18w76bwe);
  padding-right: var(--_18w76bwh);
}
.ogtkede {
  border-color: var(--_18w76bw31);
}
.ogtkedf:focus {
  outline: none;
}
.ogtkedf:focus-visible {
  outline: none;
}
.ogtkedg {
  border-color: var(--_18w76bw3k);
}
.ogtkedg:hover {
  border-color: var(--_18w76bw3k);
}
.ogtkedg:focus {
  border-color: var(--_18w76bw3k);
  box-shadow: 0 0 0 2px #FC8181;
}
.ogtkedh {
  position: absolute;
  pointer-events: none;
  width: calc(100% - 10px);
  white-space: nowrap;
  color: var(--_18w76bw2f);
  letter-spacing: var(--_18w76bw4d);
  overflow: hidden;
  transition: all .15s cubic-bezier(0,1,0,1);
}
.ogtkedo {
  color: white;
  border-color: rgba(255, 255, 255, 0.5);
}
.ogtkedo::placeholder {
  color: white;
}
.ogtkedp {
  height: var(--_18w76bwm);
  font-size: var(--_18w76bw3r);
  padding-left: 10px;
  line-height: normal;
  padding-right: 10px;
}
.ogtkedq {
  font-size: var(--_18w76bw3s);
  height: var(--_18w76bwo);
  padding-top: 0;
  padding-bottom: 0;
  padding-left: var(--_18w76bwe);
  padding-right: var(--_18w76bwe);
}
.ogtkeds {
  font-size: var(--_18w76bw3u);
  height: var(--_18w76bwp);
  padding-top: 0;
  padding-bottom: 0;
  padding-left: var(--_18w76bwe);
  padding-right: var(--_18w76bwe);
}
.ogtkedu {
  width: auto;
  height: 3px;
  top: -2px;
  padding-left: 5px;
  line-height: 0;
  overflow: visible;
  font-size: var(--_18w76bw3q);
}
.ogtkedv:focus {
  outline: none;
}
.ogtkedv:focus-visible {
  outline: none;
}
input:focused + .ogtkedw {
  color: var(--_18w76bw3k);
}
.ogtkedx {
  color: var(--_18w76bw31);
}
.ogtkedy {
  height: 3px;
}
.ogtkedz {
  color: var(--_18w76bw3k);
}
.ogtked10 {
  padding-left: var(--_18w76bwm);
}
@media screen and (min-width: 768px) {
  .ogtked0 {
    max-width: 136px;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,SAAS;EACT,gCAAgC;EAChC,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,mCAAmC;AACrC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,oBAAoB;AACtB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,YAAY;EACZ,sCAAsC;AACxC;AACA;EACE,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,gCAAgC;EAChC,kBAAkB;EAClB,+BAA+B;EAC/B,4BAA4B;AAC9B;AACA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,cAAc;EACd,iBAAiB;EACjB,8BAA8B;EAC9B,+BAA+B;AACjC;AACA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,cAAc;EACd,iBAAiB;EACjB,8BAA8B;EAC9B,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,mBAAmB;EACnB,wBAAwB;EACxB,iCAAiC;EACjC,gBAAgB;EAChB,0CAA0C;AAC5C;AACA;EACE,YAAY;EACZ,sCAAsC;AACxC;AACA;EACE,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,cAAc;EACd,iBAAiB;EACjB,8BAA8B;EAC9B,+BAA+B;AACjC;AACA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,cAAc;EACd,iBAAiB;EACjB,8BAA8B;EAC9B,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,WAAW;AACb;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,8BAA8B;AAChC;AACA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".ogtked0 {\n  max-width: 50%;\n}\n.ogtked1 {\n  display: block;\n  width: 100%;\n  appearance: none;\n  user-select: none;\n  white-space: nowrap;\n  border: 0;\n  padding: 0;\n  margin: 0;\n  border-radius: var(--_18w76bw4t);\n  transition: all 200ms;\n}\n.ogtked2 {\n  border: var(--_18w76bw4q);\n  border-color: var(--_18w76bw37);\n  background-color: var(--_18w76bw26);\n}\n.ogtked2:hover {\n  border-color: var(--_18w76bw2g);\n}\n.ogtked2:focus {\n  border-color: var(--_18w76bw2g);\n  box-shadow: none;\n  outline: none;\n}\n.ogtked5 {\n  border: none;\n  background: transparent;\n}\n.ogtked6 {\n  border: none;\n  border-radius: 0;\n  border-bottom: var(--_18w76bw4q);\n  background: transparent;\n}\n.ogtked7 {\n  background: white;\n  border-radius: var(--_18w76bw4t);\n  box-shadow: var(--_18w76bw4x);\n  outline-width: 2px;\n  outline-offset: 2px;\n  outline-color: rgba(255,255,255,0.0);\n  outline-style: solid;\n}\n.ogtked7:focus {\n  outline-color: rgba(255,255,255,0.5);\n}\n.ogtked8 {\n  color: white;\n  border-color: rgba(255, 255, 255, 0.5);\n}\n.ogtked8::placeholder {\n  color: white;\n}\n.ogtked9 {\n  height: var(--_18w76bwm);\n  padding-top: var(--_18w76bwc);\n  padding-bottom: var(--_18w76bwc);\n  padding-left: 10px;\n  padding-right: var(--_18w76bwh);\n  font-size: var(--_18w76bw3r);\n}\n.ogtkeda {\n  font-size: var(--_18w76bw3s);\n  height: var(--_18w76bwo);\n  padding-top: 0;\n  padding-bottom: 0;\n  padding-left: var(--_18w76bwe);\n  padding-right: var(--_18w76bwh);\n}\n.ogtkedc {\n  font-size: var(--_18w76bw3u);\n  height: var(--_18w76bwp);\n  padding-top: 0;\n  padding-bottom: 0;\n  padding-left: var(--_18w76bwe);\n  padding-right: var(--_18w76bwh);\n}\n.ogtkede {\n  border-color: var(--_18w76bw31);\n}\n.ogtkedf:focus {\n  outline: none;\n}\n.ogtkedf:focus-visible {\n  outline: none;\n}\n.ogtkedg {\n  border-color: var(--_18w76bw3k);\n}\n.ogtkedg:hover {\n  border-color: var(--_18w76bw3k);\n}\n.ogtkedg:focus {\n  border-color: var(--_18w76bw3k);\n  box-shadow: 0 0 0 2px #FC8181;\n}\n.ogtkedh {\n  position: absolute;\n  pointer-events: none;\n  width: calc(100% - 10px);\n  white-space: nowrap;\n  color: var(--_18w76bw2f);\n  letter-spacing: var(--_18w76bw4d);\n  overflow: hidden;\n  transition: all .15s cubic-bezier(0,1,0,1);\n}\n.ogtkedo {\n  color: white;\n  border-color: rgba(255, 255, 255, 0.5);\n}\n.ogtkedo::placeholder {\n  color: white;\n}\n.ogtkedp {\n  height: var(--_18w76bwm);\n  font-size: var(--_18w76bw3r);\n  padding-left: 10px;\n  line-height: normal;\n  padding-right: 10px;\n}\n.ogtkedq {\n  font-size: var(--_18w76bw3s);\n  height: var(--_18w76bwo);\n  padding-top: 0;\n  padding-bottom: 0;\n  padding-left: var(--_18w76bwe);\n  padding-right: var(--_18w76bwe);\n}\n.ogtkeds {\n  font-size: var(--_18w76bw3u);\n  height: var(--_18w76bwp);\n  padding-top: 0;\n  padding-bottom: 0;\n  padding-left: var(--_18w76bwe);\n  padding-right: var(--_18w76bwe);\n}\n.ogtkedu {\n  width: auto;\n  height: 3px;\n  top: -2px;\n  padding-left: 5px;\n  line-height: 0;\n  overflow: visible;\n  font-size: var(--_18w76bw3q);\n}\n.ogtkedv:focus {\n  outline: none;\n}\n.ogtkedv:focus-visible {\n  outline: none;\n}\ninput:focused + .ogtkedw {\n  color: var(--_18w76bw3k);\n}\n.ogtkedx {\n  color: var(--_18w76bw31);\n}\n.ogtkedy {\n  height: 3px;\n}\n.ogtkedz {\n  color: var(--_18w76bw3k);\n}\n.ogtked10 {\n  padding-left: var(--_18w76bwm);\n}\n@media screen and (min-width: 768px) {\n  .ogtked0 {\n    max-width: 136px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
